"use client"

import React, { createContext, useContext, useState, useEffect } from "react"

interface SidebarModeContextType {
    isEasyMode: boolean
    setIsEasyMode: (value: boolean) => void
}

const SidebarModeContext = createContext<SidebarModeContextType | undefined>(undefined)

export function SidebarModeProvider({ children }: { children: React.ReactNode }) {
    const [isEasyMode, setIsEasyModeState] = useState(false)

    useEffect(() => {
        const saved = localStorage.getItem("sidebar-easy-mode")
        if (saved === "true") setIsEasyModeState(true)
    }, [])

    const setIsEasyMode = (value: boolean) => {
        setIsEasyModeState(value)
        localStorage.setItem("sidebar-easy-mode", String(value))
    }

    return (
        <SidebarModeContext.Provider value={{ isEasyMode, setIsEasyMode }}>
            {children}
        </SidebarModeContext.Provider>
    )
}

export function useSidebarMode() {
    const context = useContext(SidebarModeContext)
    if (context === undefined) {
        throw new Error("useSidebarMode must be used within a SidebarModeProvider")
    }
    return context
}
